import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class LocationServiceService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { }

  //private apirurl  = 'https://prodmaxedge2.maxus.co.in/';
  SiteComboLoad(LocDetail: any) {
    return this.http.post<any>(environment.API_URL + `SiteMasterCombo/Load`,
      this.session.SetClass(LocDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  SiteInsert(SiteDetail: any) {
    return this.http.post<any>(environment.API_URL + `SiteMaster_Insert/Update`,
      this.session.SetClass(SiteDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  SiteMasterLoad(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteMaster_Load/Get`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  SiteMasterLoadCompress(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_SiteMaster_Load_compress/Get`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  BillCustLoad(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `GetClientGroupOnClientGroup/MasterId`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ComboLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `FillComboOnMultiple/Selections`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  //////////////////--Transovative Part--////////////////////////////

  SetSyncAPIFlagIn(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `SetSyncAPIFlagIn/Masters`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  GetMaster(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `GetMaster/Data`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  // Commented for transovative changes

  SubMasterApi(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `TransovativeSubMasterApi/Consumption`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  // SubMasterApi(SiteMasterDetail: any) {
  //   return this.http.post<any>('https://prodmaxedge2.maxus.co.in/' + `TransovativeSubMasterApi_test/Consumption`,
  //     this.session.SetClass(SiteMasterDetail)
  //   ).pipe(map(response => {
  //     if (response.Error_Code == '11' || response.Error_Code == '02') {
  //       this.session.End();
  //     } else {
  //       return response;
  //     }
  //   }));
  // }

  Transovative_SubMasterApi_ConsumptionLogs(SiteMasterDetail: any) {
    return this.http.post<any>(environment.API_URL + `Transovative_SubMasterApi_ConsumptionLogs/Insert`,
      this.session.SetClass(SiteMasterDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}